import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/logo.png';
import _imports_1 from '../../assets/search.png';

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-3dc7eb12"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "head"
};
var _hoisted_2 = {
  class: "tabs"
};

var _hoisted_3 = /*#__PURE__*/_createTextVNode(" 首页 ");

var _hoisted_4 = /*#__PURE__*/_createTextVNode(" 产品介绍 ");

var _hoisted_5 = /*#__PURE__*/_createTextVNode(" 新闻动态 ");

var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    class: "search"
  }, null, -1);
});

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("img", {
    src: _imports_0,
    class: "img",
    onClick: _cache[0] || (_cache[0] = function () {
      return _ctx.handleHome && _ctx.handleHome.apply(_ctx, arguments);
    })
  }), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
    onClick: _cache[1] || (_cache[1] = function () {
      return _ctx.handleHome && _ctx.handleHome.apply(_ctx, arguments);
    }),
    style: {
      "display": "flex",
      "flex-direction": "column",
      "align-items": "center",
      "justify-content": "center",
      "margin-right": "60px"
    }
  }, [_createElementVNode("div", {
    class: _normalizeClass(_ctx.active == 1 ? 'home1' : 'home')
  }, [_hoisted_3, _createElementVNode("div", {
    class: _normalizeClass(_ctx.active == 1 ? 'activebar' : 'activebar2')
  }, null, 2)], 2)]), _createElementVNode("div", {
    onClick: _cache[2] || (_cache[2] = function () {
      return _ctx.handleIntriduction && _ctx.handleIntriduction.apply(_ctx, arguments);
    }),
    style: {
      "display": "flex",
      "flex-direction": "column",
      "align-items": "center",
      "justify-content": "center",
      "margin-right": "60px"
    }
  }, [_createElementVNode("div", {
    class: _normalizeClass(_ctx.active == 2 ? 'home1' : 'introduction')
  }, [_hoisted_4, _createElementVNode("div", {
    class: _normalizeClass(_ctx.active == 2 ? 'activebar' : 'activebar2')
  }, null, 2)], 2)]), _createElementVNode("div", {
    onClick: _cache[3] || (_cache[3] = function () {
      return _ctx.hanldeNews && _ctx.hanldeNews.apply(_ctx, arguments);
    }),
    style: {
      "display": "flex",
      "flex-direction": "column",
      "align-items": "center",
      "justify-content": "center"
    }
  }, [_createElementVNode("div", {
    class: _normalizeClass(_ctx.active == 3 ? 'home1' : 'news')
  }, [_hoisted_5, _createElementVNode("div", {
    class: _normalizeClass(_ctx.active == 3 ? 'activebar' : 'activebar2')
  }, null, 2)], 2)]), _hoisted_6])]);
}